import React, { useState } from "react";
import { Box, Flex, Spinner } from "@theme-ui/components";
import { validate, saveForm } from "../../components/hubspot/hsAPI";
import queryString from "query-string";
import ReCAPTCHA from "react-google-recaptcha";
import { ActionBanner } from "../../components/molecules";
import { Button, InputBox } from "../../components/atoms";
import { colors } from "../../styles/theme";
import { navigate } from "gatsby";
import styled from "@emotion/styled";

let recaptchaRef = React.createRef();
const WebsiteForm = ({ search, pageUrl }) => {
  const searchParams = queryString.parse(search);
  const utm_source = searchParams["utm_source"];
  const utm_medium = searchParams["utm_medium"];
  const utm_campaign = searchParams["utm_campaign"];

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [hasError, setHasError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [hideForm, setHideForm] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const SERVER_ERROR =
    "Sorry, some error seems to have occurred and we could not complete your request. Please try again.";

  const onSubmit = async (e) => {
    e.preventDefault();
    setHasError(false);
    setProcessing(true);

    const error = validate(email);
    setEmailError(error);
    if (error) {
      setProcessing(false);
      return;
    }

    if (recaptchaRef && recaptchaRef.current) {
      let captcha = "";
      recaptchaRef.current.reset();
      captcha = await recaptchaRef.current.executeAsync();
      const payload = {
        mat_email: email,
        invisible_recaptcha: true,
        captcha,
        page_code: "HR_GARDEN_HOME",
        page_url: pageUrl,
        form_code: "WF_HR_GARDEN_HOME",
        utm_campaign,
        utm_medium,
        utm_source,
        page_name: "HR Garden Home Page",
      };
      if (captcha) {
        saveForm(
          payload,
          (response) => {
            setProcessing(false);
            setHideForm(true);
            setIsSuccess(true);
          },
          (error) => {
            setProcessing(false);
            if (
              error.response &&
              error.response.status == 400 &&
              error.response.data.mat_email
            ) {
              setEmailError(error.response.data.mat_email[0]);
            } else {
              setHideForm(true);
              setHasError(true);
              setIsSuccess(true);
            }
          }
        );
      } else {
        setProcessing(false);
        setHasError(true);
        setHideForm(true);
      }
    } else {
      setProcessing(false);
      setHasError(true);
      setHideForm(true);
    }
  };

  const refresh = () => {
    window.location.reload();
  };

  return (
    <Box
      sx={{
        mx: ["1.03rem", "1.03rem", "2rem", "3.13rem"],
        mb: ["4rem", "4rem", 0, 0],
      }}
      id="hr-garden-form"
    >
      {hideForm ? (
        <ActionBanner
          theme="primary"
          variant="BodyBannerV3"
          title={
            isSuccess ? (
              <>
                Thank you for subscribing to our HR Garden.
                <br />
                You will hear from us soon.
              </>
            ) : (
              SERVER_ERROR
            )
          }
          customStyles={actionBannerStyle}
        >
          {!isSuccess && (
            <Button variant="outlined" size="large" onClick={refresh}>
              Refresh
            </Button>
          )}
        </ActionBanner>
      ) : (
        <ActionBanner
          theme="primary"
          variant="BodyBannerV3"
          title="Get updates from HR Garden"
          customStyles={{ ...actionBannerStyle }}
        >
          <Flex
            as="form"
            onSubmit={onSubmit}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              width: "35rem",
              "@media(max-width: 900px)": {
                width: "32rem",
              },
              "@media(max-width: 600px)": {
                width: "26rem",
              },
              "@media(max-width: 480px)": {
                width: "20rem",
              },
              "@media(max-width: 360px)": {
                width: "18rem",
              },
              "@media(max-width: 320px)": {
                width: "16rem",
              },
            }}
          >
            <InputBox
              label="Business Email"
              placeholder="Type here.."
              isRequired
              labelColor={colors.white}
              errorColor={colors.white}
              name="email"
              value={email}
              maxlength={100}
              customStyles={{ width: "100%", pb: "1.5rem" }}
              error={emailError}
              onChange={(e) => setEmail(e.target.value)}
            />
            {processing ? (
              <Spinner color="white" size={58} />
            ) : (
              <Button variant="outlined" size="large" disabled={!email}>
                Subscribe
              </Button>
            )}
          </Flex>
        </ActionBanner>
      )}
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={process.env.GATSBY_INVISIBLE_RE_CAPTCHA_SITE_KEY}
        badge='bottomleft'
      />
    </Box>
  );
};

const actionBannerStyle = {
  height: ["39rem", "39rem", "26.125rem", "26.125rem"],
  alignItems: "center",
};

export default WebsiteForm;
